import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { categories: Object }

  selectCategory(event) {
    const roles = this.categoriesValue[event.target.value] || []
    this.element.querySelectorAll('input[type="checkbox"][name="document[allowed_role_codes][]"]').forEach(input => {
      input.checked = roles.includes(input.value)
    })
  }
}
